import { FC } from 'react';

type Props = {
	className?: string;
};

const AccountSetting_02_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.05193 2C8.49137 2 7.9937 2.3587 7.81644 2.8905L7.3048 4.4254L6.51344 4.92592L4.84527 4.51316C4.28804 4.37528 3.70626 4.6185 3.41295 5.11194L2.39773 6.81993C2.07756 7.35857 2.18637 8.04885 2.6567 8.46289L3.79956 9.46895V10.5312L2.65705 11.5373C2.18683 11.9514 2.0781 12.6415 2.39822 13.1802L3.4135 14.8882C3.70679 15.3816 4.28858 15.6248 4.84581 15.487L6.53073 15.0701L7.23827 15.4669L7.69957 17.06C7.86081 17.6169 8.37076 18.0002 8.9505 18.0002H11.0579C11.6377 18.0002 12.1476 17.6169 12.3089 17.06L12.7702 15.4668L13.4772 15.0701L15.1621 15.487C15.7193 15.6248 16.3011 15.3816 16.5944 14.8882L17.6288 13.1479C17.9337 12.635 17.8511 11.9805 17.4282 11.5595L16.2485 10.385L16.2488 9.61541L17.4287 8.4406C17.8516 8.01962 17.9343 7.36516 17.6294 6.85228L16.5949 5.11194C16.3016 4.6185 15.7198 4.37528 15.1627 4.51316L13.4945 4.92592L12.7031 4.4254L12.1915 2.8905C12.0142 2.3587 11.5165 2 10.956 2H9.05193ZM10.0028 5.72097C8.87258 5.72097 7.95627 6.63722 7.95627 7.7675C7.95627 8.89778 8.87258 9.81403 10.0028 9.81403C11.1331 9.81403 12.0493 8.89778 12.0493 7.7675C12.0493 6.63723 11.1331 5.72097 10.0028 5.72097ZM7.88126 12.8843C8.30552 12.1508 9.0971 11.6594 10.0028 11.6594C10.9085 11.6594 11.7001 12.1509 12.1243 12.8842C12.2787 13.1511 12.6201 13.2422 12.887 13.0879C13.1538 12.9335 13.2449 12.5921 13.0906 12.3253C12.4751 11.2611 11.3231 10.5431 10.0028 10.5431C8.68251 10.5431 7.53057 11.2612 6.915 12.3252C6.76064 12.5921 6.85182 12.9335 7.11864 13.0879C7.38547 13.2422 7.72691 13.1511 7.88126 12.8843Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default AccountSetting_02_IconSolid;
